export const appConfig = {
	name: "智能服务助手",
	title: "智能服务",
	comment: "",
	author: "学院路校区",
	// avatar: "https://qbot-1251316161.cos.ap-nanjing.myqcloud.com/avatar.png",
	avatar:"https://qidian-qbot-1251316161.cos.ap-guangzhou.myqcloud.com/public/1773234660389421056/image/nCpqyPwvZLpKKLIogCmk-1887453082234912768.png",
	is_available: true,
	bot_biz_id: '1664519736704069632',
	badWords: ["双河", "红星", "品丰华府", "卓樾", "雅苑", "华耀时代", "绿地五期", "安馨苑", "丰泽苑", "光辉四季", "御水佳园"],
	badWordsTip: "针对您这个问题，我暂时还无法进行回答，请换一个问题吧。"
};



// WEBPACK FOOTER //
// ./src/constants/appconfig.js